//配置路由
import Vue from 'vue'
import VueRouter from 'vue-router'
//使用插件
Vue.use(VueRouter)

//引入路由组件
const Home = () => import('@/pages/Home')
const Login = () => import('@/pages/Login')
const LoginStudent = () =>import('@/pages/LoginStudent')
const Register = () => import('@/pages/Register')
const Questions = () => import('@/pages/Home/Questions')
const Task = () => import('@/pages/Home/Task')
const Introduce = () => import('@/pages/Home/Introduce')
const Userinfo = () => import('@/pages/Userinfo')
const BaseInfo = () => import('@/pages/Userinfo/BaseInfo')
const MyTask = () => import('@/pages/Userinfo/MyTask')
const Account = () => import('@/pages/Userinfo/Account')
const Problem = () => import('@/pages/Home/Task/Problem')
const TaskList = () => import('@/pages/Home/Task/TaskList')
const ForgotPwd = () => import('@/pages/ForgotPsd')
const CloudResourse = () => import('@/pages/Userinfo/CloudResourse')
const NoticeDetail = () => import('@/pages/Notice/NoticeDetail')
const NoticeList = () => import('@/pages/Notice/NoticeList')
const MessageBoard = () => import('@/pages/MessageBoard')
const MessageNew = () => import('@/pages/MessageBoard/messageNew')
const MessageCreate = () => import('@/pages/MessageBoard/messageCreate')
const MyMessage = () => import('@/pages/Userinfo/MessageMy')
const ReplyNew = () => import('@/pages/MessageBoard/replyNew')
const ReplyMost = () => import('@/pages/MessageBoard/replyMost')
const MessageDetail = () => import('@/pages/MessageBoard/detail')
//配置路由
const routes = [
	{
		path: '/',
		redirect: '/home',
	},
    {
        path: '/home',
        component: Home,
		redirect: '/home/introduce',
        children: [
            {
                path: '/home/introduce',
                component: Introduce,
                meta: {
                    isShowHeader: true,
					isShowBannner: true,
                    title: '活动介绍'
                }
            },
            {
                path: '/home/questions',
                component: Questions,
                meta: {
                    isShowHeader: true,
					isShowBannner: true,
                    title: '常见问题'
                }
            },
            {
                path: '/home/task',
                component: Task,
                redirect: '/home/task/tasklist/1',
                children: [
                    {
                        path: '/home/task/tasklist/:id',
                        component: TaskList,
                        meta: {
                            isShowHeader: true,
							isShowBannner: true
                        }
                    },
                    {
                        path: '/home/task/problem',
                        component: Problem,
                        meta: {
                            isShowHeader: true,
							isShowBannner: true
                        }
                    }
                ],
                meta: {
                    isShowHeader: true,
					isShowBannner: true,
                    title: '共测任务'
                }
            }
        ],
        meta: {
            isShowHeader: true,
			isShowBannner: true,
            title: '活动介绍'
        }
    },
	{
		path: '/messageBoard',
		component: MessageBoard,
		redirect: '/messageBoard/messageNew',
		meta: {
			isShowHeader: true,
			isShowBannner: true,
			title: '留言区'
		},
		children: [
			{
				path: '/messageBoard/messageNew',
				component: MessageNew,
				meta: {
					isShowHeader: true,
					isShowBannner: true,
					title: '最新发表'
				}
			},
			{
				path: '/messageBoard/replyNew',
				component: ReplyNew,
				meta: {
					isShowHeader: true,
					isShowBannner: true,
					title: '最新回复'
				}
			},
			{
				path: '/messageBoard/replyMost',
				component: ReplyMost,
				meta: {
					isShowHeader: true,
					isShowBannner: true,
					title: '最多回复'
				}
			},
			{
				path: '/messageBoard/messageCreate',
				component: MessageCreate,
				meta: {
					isShowHeader: true,
					isShowBannner: true
				}
			},
			{
				path: '/messageBoard/messageDetail',
				component: MessageDetail,
				meta: {
					isShowHeader: true,
					isShowBannner: true
				}
			},
		]
	},
    {
        path: '/login',
        component: Login
    },
	{
		path: '/loginStudent',
		component: LoginStudent
	},
    {
        path: '/register',
        component: Register
    },
    {
        path: '/forgotpwd',
        component: ForgotPwd
    },
	{
		path: '/noticedetail/:id',
		component: NoticeDetail,
		meta: {
			isShowHeader: true,
			indexLink: true
		}
	},
	{
		path: '/noticelist',
		component: NoticeList,
		meta: {
			isShowHeader: true,
			indexLink: true
		}
	},
    {
        path: '/userinfo',
        component: Userinfo,
        redirect: '/userinfo/baseinfo',
        children: [
            {
                path: '/userinfo/baseinfo',
                component: BaseInfo
            },
            {
                path: '/userinfo/mytask',
                component: MyTask
            },
            {
                path: '/userinfo/account',
                component: Account
            },
			{
				path: '/userinfo/clondResourse',
				component: CloudResourse
			},
			{
				path: '/userinfo/messageMy',
				component: MyMessage
			}
        ]
    }
]
const router = new VueRouter({
    routes,
    mode:'history'
})
//挂载路由导航守卫控制访问权限
router.beforeEach((to,from,next)=>{
    //如果用户访问的登录页，直接放行
    if(to.path=='/login') return next()
    //从缓存中获取到保存的token值
    const tokenStr = localStorage.getItem('token')
    //没有token，强制跳转到登录页
	if(!tokenStr){
        if(to.path=='/userinfo'||to.path=='/userinfo/baseinfo'||to.path=='/userinfo/mytask'||to.path=='/userinfo/account'||to.path=='/task/problem') {
            return next('/login')
        }
    }
	next()
})
export default router